// import ReactDOM from 'react-dom/client';
// import React from 'react';
// import './helpers/i18n';
// import { Provider } from 'react-redux';
// import { store } from './store';
// import { BrowserRouter as Router } from 'react-router-dom';
// import App from './components/_APP';
// import './theme/scss/index.scss';
//
// import '@rainbow-me/rainbowkit/styles.css';
// import {
//     getDefaultConfig,
//     RainbowKitProvider,
//     darkTheme
// } from '@rainbow-me/rainbowkit';
//
// import { WagmiConfig } from 'wagmi';
// import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
// import { mainnet, polygon, bsc } from 'wagmi/chains';
//
// // Кастомная тема под твой UI
// const customTheme = darkTheme({
//     accentColor: '#FFD600',
//     accentColorForeground: '#000000',
//     overlayBlur: 'small',
//     borderRadius: 'medium',
//     fontStack: 'system',
// }).colors ? {
//     ...darkTheme(),
//     colors: {
//         ...darkTheme().colors,
//         accentColor: '#FFD600',
//         accentColorForeground: '#000000',
//         connectButtonBackground: '#0c0b02',
//         connectButtonInnerBackground: '#0c0b02',
//         modalBackground: '#0c0b02',
//         profileForeground: '#0c0b02',
//     },
//     radii: {
//         ...darkTheme().radii,
//         connectButton: '10px',
//         modal: '16px',
//     },
//     fonts: {
//         ...darkTheme().fonts,
//         body: 'Orbitron, sans-serif',
//     }
// } : darkTheme(); // fallback, если цвета не поддерживаются
//
// // Настройка Wagmi и RainbowKit
// const config = getDefaultConfig({
//     appName: 'Web3 Wallet Manual',
//     projectId: '45fb3103a73e68825a7346f3fe6c2eca',
//     chains: [mainnet, polygon, bsc],
// });
//
// const queryClient = new QueryClient();
//
// const rootElement = document.getElementById('root');
//
// if (rootElement) {
//     const root = ReactDOM.createRoot(rootElement);
//     root.render(
//         <Provider store={store}>
//             <QueryClientProvider client={queryClient}>
//                 <WagmiConfig config={config}>
//                     <RainbowKitProvider theme={customTheme} modalSize="compact">
//                         <Router>
//                             <App />
//                         </Router>
//                     </RainbowKitProvider>
//                 </WagmiConfig>
//             </QueryClientProvider>
//         </Provider>
//     );
// }


import ReactDOM from 'react-dom/client';
import React from 'react';
import './helpers/i18n';
import { Provider } from 'react-redux';
import { store } from './store';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './components/_APP';
import './theme/scss/index.scss';

import '@rainbow-me/rainbowkit/styles.css';
import {
    RainbowKitProvider,
    darkTheme
} from '@rainbow-me/rainbowkit';

import {
    WagmiConfig,
    createConfig,
    http,
    fallback, // ✅ добавили
} from 'wagmi';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { mainnet, polygon, bsc } from 'wagmi/chains';
import { injected } from 'wagmi/connectors';

// 🔹 Кастомная тема под твой UI
const baseDark = darkTheme({
    accentColor: '#FFD600',
    accentColorForeground: '#000000',
    overlayBlur: 'small',
    borderRadius: 'medium',
    fontStack: 'system',
});

const customTheme = {
    ...baseDark,
    colors: {
        ...baseDark.colors,
        accentColor: '#FFD600',
        accentColorForeground: '#000000',
        connectButtonBackground: '#0c0b02',
        connectButtonInnerBackground: '#0c0b02',
        modalBackground: '#0c0b02',
        profileForeground: '#0c0b02',
    },
    radii: {
        ...baseDark.radii,
        connectButton: '10px',
        modal: '16px',
    },
    fonts: {
        ...baseDark.fonts,
        body: 'Orbitron, sans-serif',
    },
};

// ✅ Ручной конфиг wagmi + fallback RPC для BSC
const config = createConfig({
    chains: [mainnet, polygon, bsc],
    transports: {
        [mainnet.id]: http(),   // дефолтный RPC mainnet
        [polygon.id]: http(),   // дефолтный RPC polygon

        // ✅ BSC: fallback из нескольких публичных RPC (меньше шансов на rate limit)
        [bsc.id]: fallback([
            http('https://bsc-dataseed.binance.org'),
            http('https://bsc-dataseed1.binance.org'),
            http('https://bsc-dataseed2.binance.org'),
            http('https://bsc-dataseed3.binance.org'),
            http('https://bsc-dataseed4.binance.org'),
        ]),
    },
    connectors: [
        injected(), // MetaMask / injected кошельки
    ],
    ssr: false,
});

const queryClient = new QueryClient();

const rootElement = document.getElementById('root');

if (rootElement) {
    const root = ReactDOM.createRoot(rootElement);
    root.render(
        <Provider store={store}>
            <QueryClientProvider client={queryClient}>
                <WagmiConfig config={config}>
                    <RainbowKitProvider theme={customTheme} modalSize="compact">
                        <Router>
                            <App />
                        </Router>
                    </RainbowKitProvider>
                </WagmiConfig>
            </QueryClientProvider>
        </Provider>
    );
}


